import React from 'react';
import { motion } from 'framer-motion';

const PrivacyIronFury = () => {
  return (
    <div className="pt-24 pb-20 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 legal-content">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <span className="text-accent-red font-semibold tracking-wider text-sm uppercase mb-2 block">App Specific Policy</span>
        <h1>IRON FURY Privacy Policy</h1>
        <p className="text-sm border-l-2 border-accent-red pl-4 mb-8">
          Last Updated: October 2026
        </p>

        <p>
          This document outlines the privacy practices for <strong>IRON FURY</strong>, published by
          Eager Dragon Publishing Ltd and developed by MediaVerse Labs. It is an addendum to the general
          MediaVerse Labs Privacy Policy.
        </p>

        <h2>1. No Data Collection</h2>
        <p>
          IRON FURY does not collect, transmit or store any personal information. The game has no accounts,
          no online features, no advertising and no analytics: the game engine's analytics and crash reporting
          services are switched off.
        </p>

        <h2>2. Local Save Data</h2>
        <p>
          Your progress (high scores, unlocked heroes, achievements and lifetime stats) is saved in a file in
          your Windows user folder (AppData). Settings such as volume, language and controls are saved in your
          Windows user settings. Nothing leaves your device, and uninstalling the game removes this data.
        </p>

        <h2>3. Store Platforms</h2>
        <p>
          The game is distributed through the Microsoft Store, Steam and the Epic Games Store. Each store may
          collect information about purchases, installation, play time, achievements and crashes under its own
          privacy policy. We do not receive personal data from them beyond the anonymous sales and usage
          reports they provide to publishers.
        </p>

        <h2>4. Children</h2>
        <p>
          Because the game collects no personal data, it does not knowingly collect data from children of any age.
        </p>

        <h2>5. Contact</h2>
        <p>
          For privacy inquiries: <a href="mailto:hello@mediaverselabs.com">hello@mediaverselabs.com</a>
        </p>
      </motion.div>
    </div>
  );
};

export default PrivacyIronFury;
